import React, {useEffect, useState} from "react";
import AlertInfo from "../../../ui/AlertInfo";
import useClusterService from "../../../../services/ClusterService";
import ReportTime from "../ui/ReportTime";
import SystemEntityStatus from "../ui/SystemEntityStatus";
import numeral from "numeral";
import CriticalLogCount from "../ui/CriticalLogCount";
import LoadingDialog from "../../../misc/LoadingDialog";

export default function NodesTable(props) {

  const clusterService = useClusterService();

  const cluster = props.cluster;

  const [nodes, setNodes] = useState(null);

  useEffect(() => {
    clusterService.findNodesOfCluster(cluster.uuid, setNodes);
  }, [cluster]);

  if (nodes == null) {
    return <LoadingDialog />
  }

  if (nodes.nodes.length === 0) {
    return <AlertInfo>No nodes found.</AlertInfo>
  }

  return (
      <React.Fragment>

        <p>
          {nodes.nodes.length} {nodes.nodes.length > 1 ? "nodes" : "node"} in this cluster.
        </p>

        <div className="table-responsive">
          <table className="table table-hover">
            <thead>
            <tr>
              <th>Name</th>
              <th>CPU</th>
              <th>Memory</th>
              <th>JVM Heap</th>
              <th>Critical Logs</th>
              <th>Last Report</th>
            </tr>
            </thead>
            <tbody>
            {nodes.nodes.map((n, i) => {
              if (n.status === "ONLINE") {
                return (
                    <tr key={i}>
                      <td>
                        <SystemEntityStatus status={n.status}/>{' '}
                        {n.name}
                      </td>
                      <td>{numeral(n.cpu_utilization).format("0,0.0")}%</td>
                      <td>{numeral(n.memory_utilization).format("0,0.0")}%</td>
                      <td>{numeral(n.heap_utilization).format("0,0.0")}%</td>
                      <td><CriticalLogCount count={n.critical_logs} /></td>
                      <td><ReportTime time={n.last_report_received_at}/></td>
                    </tr>
                )
              } else {
                return (
                    <tr key={i}>
                      <td>
                        <SystemEntityStatus status={n.status}/>{' '}
                        {n.name}
                      </td>
                      <td className="color-muted">n/a</td>
                      <td className="color-muted">n/a</td>
                      <td className="color-muted">n/a</td>
                      <td className="color-muted">n/a</td>
                      <td><ReportTime time={n.last_report_received_at}/></td>
                    </tr>
                )
              }
            })}
            </tbody>
          </table>
        </div>
      </React.Fragment>
  )

}